class Corrections {
  constructor() {

    this.titles = document.querySelectorAll('.ns-title-h2');    

    if(this.titles){
      this.correctionOrganigramm();
    }
  }

  correctionOrganigramm(){
    this.titles.forEach(title => {
      if(title.innerHTML == 'Organigramm'){
        title.nextElementSibling.classList.add('ns-organi');
      }
    })
  }

}

export default Corrections;
